import { FC } from 'react';

import cn from 'classnames';
import DatePicker from 'react-datepicker';
import { Controller, useFormContext } from 'react-hook-form';
import { FormattedMessage } from 'react-intl';

import { DateFormates } from 'constants/date.constants';
import { REQUIRED_VALIDATION } from 'constants/validation-rules.constants';
import { AuditInput } from 'interfaces/audits.interfaces';
import { ErrorMessage } from 'shared-components/ErrorMessage';
import { FormLabel } from 'shared-components/FormLabel';

interface Props {
  defaultStart: Date;
  isEditable: boolean;
}

export const AuditDatesFields: FC<Props> = ({ defaultStart, isEditable }) => {
  const {
    control,
    formState: { errors },
  } = useFormContext<AuditInput>();

  return (
    <>
      <div className={cn({ 'flex gap-2 items-center': !isEditable })}>
        <FormLabel
          htmlFor='plannedAt'
          className={cn('mb-2 flex', { 'text-black whitespace-nowrap mb-0': !isEditable })}
        >
          <FormattedMessage id='planned_date' />
          {isEditable && '*:'}
        </FormLabel>
        <Controller
          control={control}
          name='planned'
          defaultValue={defaultStart as unknown as string}
          rules={REQUIRED_VALIDATION}
          render={({ field: { value, onChange, ...field } }) => (
            <DatePicker
              {...field}
              showIcon
              disabled={!isEditable}
              minDate={defaultStart}
              onChange={(date) => {
                date && onChange(date);
              }}
              selected={value ? new Date(value) : defaultStart}
              dateFormat={DateFormates.defaultDate}
              className='flex-1 h-full disabled:border-0'
              wrapperClassName='w-full'
            />
          )}
        />
        <ErrorMessage>{errors['planned']?.message}</ErrorMessage>
      </div>
    </>
  );
};
